<template>
  <div class="section dark_orange">
    <div class="part part-budget-menages">
      <p class="label main_color_text">{{ perimetre_subtitle }}</p>
      <div class="tle-row">
        <div class="tle-col two-third">
          <table class="table-loyers">
            <div class="menages-edit" v-show="editor.mode == 'editing'">
              <div class="box-edit-line">
                <label class="label-edit">Choix des déciles de ménage</label>
                <br />
                <input type="radio" id="5e6e7e" value="5e6e7e" v-model="decile" />
                <label for="one">5ème/6ème/7ème</label>
                <br />
                <input type="radio" id="6e7e8e" value="6e7e8e" v-model="decile" />
                <label for="one">6ème/7ème/8ème</label>
                <br />
                <input type="radio" id="7e8e9e" value="7e8e9e" v-model="decile" />
                <label for="one">7ème/8ème/9ème</label>
                <br />
              </div>
              <div class="box-edit-line">
                <label class='label-edit'>Zone géographique</label>
                <br />
                <input type="radio" id="epci" value="epci" v-model="zone_geo" :disabled="!parameters.geo.epci"/>
                <label for="one">Agglomération (EPCI)</label>
                <br />
                <input type="radio" id="commune" value="commune" v-model="zone_geo" :disabled="!parameters.geo.commune" />
                <label for="one">Commune</label>
              </div>
            </div>

            <thead>
              <tr>
                <th width="40%"></th>
                <th width="20%">
                  <span class="name">
                    <div class="th-icon">
                      <icon file="menages-1p" :size="48" folder="" />
                    </div>
                    {{component_value.content.data_list[0].label}}
                  </span>
                </th>
                <th width="20%">
                  <span class="name">
                    <div class="th-icon">
                      <icon file="menages-3p" :size="48" folder="" />
                    </div>
                    {{component_value.content.data_list[1].label}}
                  </span>
                </th>
                <th width="20%">
                  <span class="name">
                    <div class="th-icon">
                      <icon file="menages-4p" :size="48" folder="" />
                    </div>
                    {{component_value.content.data_list[2].label}}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="strong">Répartition des ménages</td>
                <td>{{ component_value.content.data_list[0].values[0].value }}{{component_value.content.data_list[0].values[0].unit}}</td>
                <td>{{ component_value.content.data_list[1].values[0].value }}{{component_value.content.data_list[1].values[0].unit}}</td>
                <td>{{ component_value.content.data_list[2].values[0].value }}{{component_value.content.data_list[2].values[0].unit}}</td>
              </tr>
              <!-- <tr>
                <td class="strong">Ménages 1 personne</td>
                <td>{{ repart_menages['1_personne'][repart_menages_field] | to_float | percent }}</td>
                <td>{{ DECILES.P1.typo }}</td>
                <td>{{ decile_data(CHOSEN_DECILES[decile]['decile1']).revenu_global | euro }}</td>
                <td>{{ decile_data(CHOSEN_DECILES[decile]['decile1']).revenu_global | loyer | euro }}</td>
                <td>{{ get_rent_text(active_study.etudeData.marche_locatif.loyers_neufs.t2.loyer_hc_hs_min, active_study.etudeData.marche_locatif.loyers_neufs.t2.loyer_hc_hs_max) }}</td>
              </tr> -->
              <tr>
                <td class="strong">Type associé</td>
                <td v-for="col in ['1', '2_3', '4_5']" :key="col">
                  <el-select
                    behavior="dialog"
                    :parent_data="active_study.etudeData.budget_menages.menages[`p${col}`]"
                    property="type_associe"
                    :options="Object.values(active_study.etudeData.marche_locatif.loyers_neufs).map((loyer, index) => ({label: loyer.type, value: index}))"
                    :editable="true"
                    dense
                  />
                </td>
              </tr>
              <tr>
                <td class="strong">Revenu max.</td>
                <td>{{ component_value.content.data_list[0].values[2].values.find((val)=>{return val.decile == Object.keys(DECILE_LABELS).indexOf(decile) + 1}).value }}{{component_value.content.data_list[0].values[2].unit}}</td>
                <td>{{ component_value.content.data_list[1].values[2].values.find((val)=>{return val.decile == Object.keys(DECILE_LABELS).indexOf(decile) + 1}).value }}{{component_value.content.data_list[1].values[2].unit}}</td>
                <td>{{ component_value.content.data_list[2].values[2].values.find((val)=>{return val.decile == Object.keys(DECILE_LABELS).indexOf(decile) + 1}).value }}{{component_value.content.data_list[2].values[2].unit}}</td>
              </tr>
              <tr>
                <td class="strong">Loyer max. HC</td>
                <td>{{ component_value.content.data_list[0].values[3].values.find((val)=>{return val.decile == Object.keys(DECILE_LABELS).indexOf(decile) + 1}).value }}{{component_value.content.data_list[0].values[3].unit}}</td>
                <td>{{ component_value.content.data_list[1].values[3].values.find((val)=>{return val.decile == Object.keys(DECILE_LABELS).indexOf(decile) + 1}).value }}{{component_value.content.data_list[1].values[3].unit}}</td>
                <td>{{ component_value.content.data_list[2].values[3].values.find((val)=>{return val.decile == Object.keys(DECILE_LABELS).indexOf(decile) + 1}).value }}{{component_value.content.data_list[2].values[3].unit}}</td>
              </tr>
              <tr>
                <td class="strong">Loyer pratiqué localement</td>
                <td v-for="col in [{amount: '1', defaultType: 't2'}, {amount: '2_3', defaultType: 't3'}, {amount: '4_5', defaultType: 't4'}]" :key="col.amount">
                  {{ get_rent_text(
                    active_study.etudeData.marche_locatif.loyers_neufs[`t${parseInt(active_study.etudeData.budget_menages.menages[`p${col.amount}`]['type_associe']) + 1}`] ?
                      active_study.etudeData.marche_locatif.loyers_neufs[`t${parseInt(active_study.etudeData.budget_menages.menages[`p${col.amount}`]['type_associe']) + 1}`]['loyer_hc_hs_min']
                      : active_study.etudeData.marche_locatif.loyers_neufs[col.defaultType].loyer_hc_hs_min,
                    active_study.etudeData.marche_locatif.loyers_neufs[`t${parseInt(active_study.etudeData.budget_menages.menages[`p${col.amount}`]['type_associe']) + 1}`] ?
                    active_study.etudeData.marche_locatif.loyers_neufs[`t${parseInt(active_study.etudeData.budget_menages.menages[`p${col.amount}`]['type_associe']) + 1}`]['loyer_hc_hs_max'] : active_study.etudeData.marche_locatif.loyers_neufs[col.defaultType].loyer_hc_hs_max) }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <p class="source" style="width:150%;">
            Les informations présentées sont celles correspondant aux ménages dont les revenus sont ceux des {{ DECILE_LABELS[decile] }} (30% des ménages). Ces catégories correspondent à la cible privilégiée pour le LLI. * Répartition des ménages des {{ DECILE_LABELS[decile] }} | ** Voir rubrique précédente
          </p> -->
          <!-- Display error div -->
          <div  v-if="is_edit_mode && (component_value && component_value.error)  "  class="error-container edit-error">
              <div class='content-error'>{{component_value.error_message}}</div>
          </div>
          <div  v-if="!is_edit_mode && (component_value && component_value.error)  "  class="error-container read-error">
              <div class='content-error'>{{component_value.error_message}}</div>
          </div>

        </div>
        <div class="tle-col one-third">
          <div class="comment">
            <el-textarea
              :parent_data="active_study.etudeData.budget_menages"
              property="commentaire"
              :editable="true"
              placeholder="Indiquer le niveau de tension locative (sous offre ou sur offre ?)"
              height='220px'
              overflow_edit='hidden scroll'
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-budget-menages-lli",
	mixins: [PageMixin],
	data: function () {
		const DECILE_DATA = {
			P1: {
				typo: "T2",
				revenus: {
					VILLE: { "5e6e7e": 2768, "6e7e8e": 3325, "7e8e9e": 3759 },
					AGGLO: { "5e6e7e": 3317, "6e7e8e": 3904, "7e8e9e": 4554 }
				},
				part_menages: {
					VILLE: 0.2,
					AGGLO: 0.28
				}
			},
			P2_3: {
				typo: "T3",
				revenus: {
					VILLE: { "5e6e7e": 3325, "6e7e8e": 3759, "7e8e9e": 4240 },
					AGGLO: { "5e6e7e": 3904, "6e7e8e": 4554, "7e8e9e": 5398 }
				},
				part_menages: {
					VILLE: 0.44,
					AGGLO: 0.47
				}
			},
			P4_5: {
				typo: "T4",
				revenus: {
					VILLE: { "5e6e7e": 3759, "6e7e8e": 4240, "7e8e9e": 5371 },
					AGGLO: { "5e6e7e": 4554, "6e7e8e": 5398, "7e8e9e": 6762 }
				},
				part_menages: {
					VILLE: 0.36,
					AGGLO: 0.25
				}
			}
		};

		const chosen_deciles = {
			"5e6e7e": {
				decile1: "5eme_decile",
				decile2: "6eme_decile",
				decile3: "7eme_decile",
			},
			"6e7e8e": {
				decile1: "6eme_decile",
				decile2: "7eme_decile",
				decile3: "8eme_decile",
			},
			"7e8e9e": {
				decile1: "7eme_decile",
				decile2: "8eme_decile",
				decile3: "9eme_decile",
			},
		};

		const decile_labels = {
			"5e6e7e": "5ème, 6ème et 7ème déciles",
			"6e7e8e": "6ème, 7ème et 8ème déciles",
			"7e8e9e": "7ème, 8ème et 9ème déciles",
		};

		return {
			// zone_geo: "epci",
			//decile: "5e6e7e",
			CHOSEN_DECILES: chosen_deciles,
			DECILE_LABELS: decile_labels,
			DECILES: DECILE_DATA
		};
	},
	props: [],
	computed: {
		...mapGetters(["active_study","etude_data", "editor","app_parameters"]),
		parameters () {
			try {
				const parametersPromo =
				this.active_study.qlikData.parameters.editmode.find((editmode) => {return editmode.theme == "budget_menage";});
				return parametersPromo;
			} catch (e) {
				return false;
			}
		},
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		},
		repart_menages_field () {
			if (this.zone_geo === "epci") {
				return "repart_menages_siren";
			}
			return "repart_menages";
		},
		perimetre_subtitle () {
			let component = {};
			let result = "";
      
			try{
				component = this.active_study.qlikData.component.find((component) => {
					return component.name == "menages" || component.id == "6.1";
				});
        
				if (this.zone_geo === "epci") {
					return component.title[1].value;
				}
				result = component.title[0].value;
			}catch(error){
				result = "";
				//Todo : display error
			}
			return result;
		},
		component_value: function (){
			const result = {};
    
			try{
				const component = this.active_study.qlikData.component.find((component) => {
					return component.name == "menages" || component.id == "6.1";
				});
				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				if(component.valid == false){
         
					result.error = true;
					// result.error_message = "[BACK] : "+component.errorMessage;
					result.error_message = "Donnée non disponible";
                      
					const component = this.app_parameters.default_components.find((component) => {
						return component.name == "menages" || component.id == "6.1";
					});
					result.content = component.content.epci;
				}else{
					result.content = component.content[this.zone_geo];
				}

				// check if data are availables => throw error if not!
				result.content.data_list[0].label;
			}catch(error){
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == "menages" || component.id == "6.1";
				});

				result.error = true;
				// result.error_message = "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				result.error_message = "Donnée non disponible";
				result.content = component.content.epci;
			}
			return result;
		},
		decile: {
			get () {
				if (this.active_study.etudeData.budget_menages.decile) {
					return this.active_study.etudeData.budget_menages.decile;
				}
				return "5e6e7e";
			},
			set: function (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.budget_menages,
					field: "decile",
					value: value,
				});
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.budget_menages,
					field: "decile_label",
					value: this.DECILE_LABELS[value],
				});
			}
		},
		zone_geo: {
			get () {
				//get from qlik_data
				const geo_default = this.parameters.geo.default;
				if (this.active_study.etudeData.budget_menages.zone_geo) {
					return this.active_study.etudeData.budget_menages.zone_geo;
				}
				return geo_default;
			},
			set: function (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.budget_menages,
					field: "zone_geo",
					value: value,
				});
			}
		},
	},
	methods: {
		decile_data (chosen_decile) {
			return this.deciles[this.zone_geo][chosen_decile];
		},
		get_rent_text (v1, v2) {
			if (v1 && !v2) return `${v1} €`;
			if (!v1 && v2) return `${v2} €`;
			if (!v1 && !v2) return "-";
			if (v1 == "-" && v2 == "-") return "-";
			return `${v1} à ${v2} €`;
		}
	},
	components: {}
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'


.error-container
  z-index: 20000
  position absolute
  top 0
  left 0
  width 100% !important
  height 100% !important
  text-align center
  border-style solid
  border-width 2px
	.content-error
		position relative
		top 50%
		transform translateY(-50%)


.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red

.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58

.menages-edit
  position absolute
  top 0
  right 560px
  width 240px
  background-color lighten(purple, 85%)
  box-shadow 0 0 0 2px #ddd
  z-index 10001

  &:after
    content ''
    position absolute
    left -8px
    top 24px
    width 0
    height 0
    border-style solid
    border-width 8px 0 8px 8px
    border-color transparent #ddd transparent transparent

  .box-edit-line
    padding 8px 16px
    border-bottom 1px solid #eee
    text-align left

    input[type='radio']
      vertical-align baseline
      padding 4px
      margin 4px
      color lighten(purple, 85%)

    input[type='radio'] + label
      margin-left 4px

    .label-edit
      display inline-block
      text-transform uppercase
      font-size 10px
      font-weight 500

    input[type='range']
      display inline-block
      width 75%

    .value
      float right
      width 25%
      padding 0 0 0 8px
      font-weight 500
      text-align center
      white-space nowrap

    .delete
      display block
      margin 4px 0
      padding 8px
      background-color red
      border-radius radius
      text-align center
      color #fff
      font-weight 500
      cursor pointer

      &:hover
        background-color darken(red, 25%)
  
.th-icon
  width 50px
  height 50px
  border-radius 25px
  padding 12px
  background-color main_color
  color #fff
  display flex
  align-items center
  justify-content center
  margin 0 auto
  margin-bottom 5px
</style>